import {AuthErrorNames} from '@/services';

const TOAST = {
  MAXIMUM_ATTEMPTS: {
    TITLE: 'Maximum attempts',
    DETAILS: 'You have exceeded the maximum number of attempts',
  },
  FAILED: {
    TITLE: 'Send recovery email problem',
    DETAILS:
      'Check the email and try again. If the situation persists, contact our Customer Service',
  },
};

export const errorMap = {
  [AuthErrorNames.LimitExceededException]: TOAST.MAXIMUM_ATTEMPTS,
};

export const defaultToast = TOAST.FAILED;
